// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YBw2","title":"Info_title__2Rlol","selects":"Info_selects__1S8F1","requiredAsterisk":"Info_requiredAsterisk__2-3Dn"};